var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSuccessCheck2 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 102,
  height: 102,
  viewBox: "0 0 102 102",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.59375 92.4375C1.59375 93.3141 2.31094 94.0312 3.1875 94.0312H98.8125C99.6891 94.0312 100.406 93.3141 100.406 92.4375V14.3438H1.59375V92.4375Z",
  fill: "#E6E9ED"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.315 63.7301C63.6392 63.7301 73.63 53.7393 73.63 41.4151C73.63 29.0909 63.6392 19.1001 51.315 19.1001C38.9908 19.1001 29 29.0909 29 41.4151C29 53.7393 38.9908 63.7301 51.315 63.7301Z",
  fill: "#25AE88"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.1719 25.6294C62.2026 20.6585 55.4786 18.5325 49 19.2289C53.888 19.7517 58.6374 21.8778 62.3859 25.6294C71.1037 34.3457 71.1037 48.4679 62.3859 57.1841C58.6358 60.9358 53.888 63.0587 49 63.5846C55.4786 64.2795 62.2026 62.1566 67.1719 57.1841C75.8897 48.4679 75.8897 34.3441 67.1719 25.6294Z",
  fill: "#1F9977"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.2076 33.1001L48.926 49.1669L40 42.0261",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M100.406 11.1562V14.3438H1.59375V11.1562C1.59375 9.38878 3.01219 7.96875 4.78125 7.96875H97.2188C98.9878 7.96875 100.406 9.38878 100.406 11.1562Z",
  fill: "#CCD1D9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.38456 9.55957H6.36862C5.48887 9.55957 4.78284 10.272 4.78284 11.1533C4.78284 12.0331 5.50481 12.7471 6.38456 12.7471C7.2659 12.7471 7.97831 12.0331 7.97831 11.1533C7.97831 10.272 7.2659 9.55957 6.38456 9.55957Z",
  fill: "#E6E9ED"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1642 9.55957H11.1483C10.2669 9.55957 9.5625 10.272 9.5625 11.1533C9.5625 12.0331 10.2829 12.7471 11.1642 12.7471C12.0456 12.7471 12.758 12.0331 12.758 11.1533C12.758 10.272 12.0456 9.55957 11.1642 9.55957Z",
  fill: "#E6E9ED"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9502 9.55957H15.9343C15.0545 9.55957 14.3485 10.272 14.3485 11.1533C14.3485 12.0331 15.0705 12.7471 15.9502 12.7471C16.8316 12.7471 17.544 12.0331 17.544 11.1533C17.544 10.272 16.8316 9.55957 15.9502 9.55957Z",
  fill: "#E6E9ED"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M87.6642 71.73H14.3293C13.448 71.73 12.7356 71.0176 12.7356 70.1362C12.7356 69.2549 13.448 68.5425 14.3293 68.5425H87.6642C88.5455 68.5425 89.2579 69.2549 89.2579 70.1362C89.2579 71.0176 88.5455 71.73 87.6642 71.73Z",
  fill: "#CCD1D9"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M73.3173 76.5127H28.6764C27.795 76.5127 27.0826 75.8003 27.0826 74.9189C27.0826 74.0376 27.795 73.3252 28.6764 73.3252H73.3173C74.1987 73.3252 74.9111 74.0376 74.9111 74.9189C74.9111 75.8003 74.1987 76.5127 73.3173 76.5127Z",
  fill: "#CCD1D9"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2512 83.6782H67.7423V85.2736H34.2512V83.6782Z",
  fill: "#545C66"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5548 82.0859H37.4387C35.6808 82.0859 34.2512 83.5155 34.2512 85.2734C34.2512 87.0313 35.6808 88.4609 37.4387 88.4609H64.5548C66.3127 88.4609 67.7423 87.0313 67.7423 85.2734C67.7423 83.5155 66.3111 82.0859 64.5548 82.0859Z",
  fill: "#545C66"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5548 80.4907H37.4387C35.6808 80.4907 34.2512 81.9203 34.2512 83.6782C34.2512 85.4361 35.6808 86.8657 37.4387 86.8657H64.5548C66.3127 86.8657 67.7423 85.4361 67.7423 83.6782C67.7423 81.9203 66.3111 80.4907 64.5548 80.4907Z",
  fill: "#656D78"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44.63,
  height: 44.63,
  fill: "white",
  transform: "translate(29 19.1001)"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccessCheck2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success-check2.d8e766ea.svg";
export { ForwardRef as ReactComponent };